
/**
 * Handle error messages in a consistent way
 * @param error The error object
 * @param fallbackMessage A fallback message to display if no error message is available
 * @returns A user-friendly error message
 */
export function handleError(error: any, fallbackMessage: string = "An error occurred"): string {
  // Check if it's a string error
  if (typeof error === 'string') {
    return error;
  }
  
  // Check if there's a message property
  if (error?.message) {
    return error.message;
  }
  
  // Check for Supabase error format
  if (error?.error_description) {
    return error.error_description;
  }
  
  // Return the fallback message if no specific error info is found
  return fallbackMessage;
}

/**
 * Parse Supabase data safely with proper type checking
 * @param data The data from a Supabase query
 * @param defaultValue A default value to return if data is undefined or null
 * @returns The data or default value
 */
export function parseDatabaseData<T>(data: T | null | undefined, defaultValue: T): T {
  return data !== null && data !== undefined ? data : defaultValue;
}
